import { render, staticRenderFns } from "./retouch.vue?vue&type=template&id=0c269efb&scoped=true&"
import script from "./retouch.vue?vue&type=script&lang=js&"
export * from "./retouch.vue?vue&type=script&lang=js&"
import style0 from "./retouch.vue?vue&type=style&index=0&id=0c269efb&prod&lang=stylus&scoped=true&"
import style1 from "./retouch.vue?vue&type=style&index=1&id=0c269efb&prod&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c269efb",
  null
  
)

export default component.exports